import React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'gatsby-plugin-intl'

const OrderDetails = ({ className, order }) => {
  const hasSplitLocations =
    order.loadingCompanyName ||
    order.loadingAddress ||
    order.loadingDate ||
    order.loadingTime ||
    order.unloadingCompanyName ||
    order.unloadingAddress ||
    order.unloadingDate ||
    order.unloadingTime

  const cargoDetails = [order.container, order.shipowner || order.cargoType]
    .filter(Boolean)
    .join(', ')
  const forwarder = [
    order.forwarder?.company,
    order.forwarder?.name ? `(${order.forwarder.name})` : ''
  ]
    .filter(Boolean)
    .join(' ')
  const details = [
    {
      key: 'transportationType',
      value: order.transportationType ? (
        <FormattedMessage id={`common.${order.transportationType}`} />
      ) : null
    },
    {
      key: 'loadingUnloadingCompanyName',
      value: !hasSplitLocations ? order.loadingUnloadingCompanyName : null
    },
    {
      key: 'loadingUnloadingAddress',
      value: !hasSplitLocations ? order.loadingUnloadingAddress : null
    },
    {
      key: 'loadingUnloadingDate',
      value:
        !hasSplitLocations && order.loadingUnloadingDate ? (
          <span>{order.loadingUnloadingDate}</span>
        ) : null
    },
    {
      key: 'loadingUnloadingTime',
      value:
        !hasSplitLocations && order.loadingUnloadingTime ? (
          <span>{order.loadingUnloadingTime}</span>
        ) : null
    },
    {
      key: 'loadingCompanyName',
      value: hasSplitLocations ? order.loadingCompanyName : null
    },
    {
      key: 'loadingAddress',
      value: hasSplitLocations ? order.loadingAddress : null
    },
    {
      key: 'loadingDate',
      value:
        hasSplitLocations && order.loadingDate ? (
          <span>{order.loadingDate}</span>
        ) : null
    },
    {
      key: 'loadingTime',
      value:
        hasSplitLocations && order.loadingTime ? (
          <span>{order.loadingTime}</span>
        ) : null
    },
    {
      key: 'unloadingCompanyName',
      value: hasSplitLocations ? order.unloadingCompanyName : null
    },
    {
      key: 'unloadingAddress',
      value: hasSplitLocations ? order.unloadingAddress : null
    },
    {
      key: 'unloadingDate',
      value:
        hasSplitLocations && order.unloadingDate ? (
          <span>{order.unloadingDate}</span>
        ) : null
    },
    {
      key: 'unloadingTime',
      value:
        hasSplitLocations && order.unloadingTime ? (
          <span>{order.unloadingTime}</span>
        ) : null
    },
    { key: 'cargoDetails', value: cargoDetails },
    { key: 'forwarder', value: forwarder }
  ].filter(({ value }) => value)

  return (
    <div className={className}>
      <Text>
        {details.map(({ key, value }, index) => (
          <React.Fragment key={key}>
            {index > 0 && ', '}
            {value}
          </React.Fragment>
        ))}
      </Text>
    </div>
  )
}

export default styled(OrderDetails)`
  width: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;
  min-height: 20px;
  line-height: 1;
`

const Text = styled.span`
  display: inline;
  font-size: 0.7rem;
  font-weight: 400;
  line-height: 1;
  color: ${({ theme }) => theme.colors.ebonyClay.hex()};
  span {
    color: ${({ theme }) => theme.colors.ebonyClay.alpha(0.6).hex()};
  }
`
